var _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.5773 14.4C48.5744 13.7206 48.3032 13.0699 47.8228 12.5895C47.3424 12.1091 46.6917 11.8379 46.0123 11.835H8.00984C7.32852 11.835 6.67494 12.1048 6.19213 12.5855C5.70931 13.0663 5.43657 13.7186 5.43359 14.4V17.1337H48.5886L48.5773 14.4Z",
    fill: "#1552DD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.42238 39.6C5.42536 40.2813 5.6981 40.9337 6.18092 41.4144C6.66373 41.8951 7.31731 42.165 7.99863 42.165H45.9899C46.6712 42.165 47.3248 41.8951 47.8076 41.4144C48.2904 40.9337 48.5632 40.2813 48.5661 39.6V23.0513H5.41113L5.42238 39.6Z",
    fill: "url(#paint0_linear_3369_2072)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5774 17.1338H5.42236V23.0513H48.5774V17.1338Z",
    fill: "#FFC522"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2136 28.7549H35.8086V36.7649H45.2136V28.7549Z",
    fill: "#FFD767"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3369_2072",
    x1: 26.9886,
    y1: 23.0513,
    x2: 26.9886,
    y2: 42.165,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2666FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C46CC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard);
export default __webpack_public_path__ + "static/media/card.8602d358e8dc4fef1ae38503023ae58e.svg";
export { ForwardRef as ReactComponent };